import(/* webpackMode: "eager" */ "/home/runner/work/rstu-connect/rstu-connect/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ClientLayout"] */ "/home/runner/work/rstu-connect/rstu-connect/src/components/layout/ClientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistration"] */ "/home/runner/work/rstu-connect/rstu-connect/src/components/shared/ServiceWorkerRegistration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VersionInfo"] */ "/home/runner/work/rstu-connect/rstu-connect/src/components/shared/VersionInfo.tsx");
